export default __webpack_public_path__ + "static/media/loyalty-blue.8da38b6c.svg";